module.exports = __webpack_public_path__ + "static/img/Seven of Wands.1bcc80d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Seven of Wands.jpg
// module id = 1298
// module chunks = 0